import request from '@/request'

export function getProductList(){
    return request({
        url:'/product/getList',
        method:'get',
    })
}

export function getClassfications(){
    return request({
        url:'/product/classfications',
        method:'get',
    })
}

export function getImageById(id){
    return request({
        url:'/product/getImageById',
        method:'post',
        data:id
    })
}

export function getProductById(id)
{
    return request({
        url:'/product/getProductById',
        method:'post',
        data:id,
    })
}

export function findBypaging(pageparam)
{
    return request({
        url:'/product/findBypaging',
        method:'post',
        data:pageparam,
    })
}

export function findByClassfication(pageparam)
{
    return request({
        url:'/product/findByClassfication',
        method:'post',
        data:pageparam,
    })
}